<template>
  <div
    v-if="config"
    class="test-prep-container"
  >
    <div class="top">
      <dashboard-widget-header
        :title="config.name"
        :icon="widgetIcon"
      />
      <router-link
        v-if="topItem"
        :to="topItem.route"
        @click="sendAnalytics(topItem)"
      >
        {{ topItem.name }}
      </router-link>
    </div>
    <div class="nav-link-container">
      <template v-for="item in lowerItems" :key="item.id">
        <router-link
          :to="item.route"
          @click="sendAnalytics(item)"
        >
          {{ item.name }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import DashboardWidgetMixin from '@/mixins/dashboardWidget';
import GlobalMixin from '@/mixins/global';

export default {
  components: { DashboardWidgetHeader },
  mixins: [DashboardWidgetMixin, GlobalMixin],
  props: {
    config: {
      type: Object,
    },
  },
  computed: {
    lowerItems() {
      return this.navigationItems?.filter(ni => ni.destination !== 'progress');
    },
    topItem() {
      return this.navigationItems?.find(ni => ni.destination === 'progress');
    },
  },
  methods: {
    sendAnalytics(navItem) {
      this.$analytics.events.selectedNavItem(navItem, this.navigationGroup, this.config.widgetType);
    },
  },
};
</script>

<style lang='scss' scoped>
.test-prep-container {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  margin: 20px 0;
  padding: rem-calc(32) !important;

  @include breakpoint(small) {
    box-shadow: none;
    margin: 8px auto;
    padding: rem-calc(16);
  }

  .nav-link-container {
    align-content: center;
    display: flex;

    @include breakpoint(small) {
      flex-wrap: wrap;
    }

    > a {
      align-items: center;
      background: white;
      border: 3px solid #6f0079;
      border-radius: 40px;
      color: #6f0079;
      display: flex;
      font-size: 16px;
      font-weight: $bold;
      height: 56px;
      justify-content: center;
      margin: 0 8px;
      padding: 0 12px;
      text-align: center;
      width: 200px;

      @include breakpoint(small) {
        font-size: 14px;
        height: 40px;
        margin: 16px auto 0 auto;
      }

      &:hover {
        background: #6f0079;
        color: white;
      }
    }

  }

  .top {
    display: flex;
    margin-bottom: 24px;

    @include breakpoint(small) {
      margin-bottom: 12px;
    }

    // remove margin from header
    :deep(.dashboard-widget-header) {
      margin-bottom: 0;
    }

    > a {
      border: 1px solid #d5d5d5;
      border-radius: 4px;
      color: black;
      font-size: 16px;
      font-weight: $semi-bold;
      padding: 8px 20px;
    }
  }

}
</style>
